import styled from 'styled-components/macro'

const ResultActions = styled.div`
  float: left;
  width: 100%;
`

export default ResultActions
